// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__Th3Ep","itemMenu":"styles_itemMenu__+W-cM","background":"styles_background__xl+iE","horizontalLine":"styles_horizontalLine__MBtHC"};